import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Tours from "@/components/site/Tours";
import About from "@/components/site/About";
import BookingForm from "@/components/site/BookingForm";
import Contact from "@/components/site/Contact";
import Reviews from "@/components/site/Reviews";
import Footer from "@/components/site/Footer";
import FloatingButtons from "@/components/site/FloatingButtons";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

const Home = () => (
  <div className="bg-[color:var(--bg-primary)] text-white">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <Tours />
      <Reviews />
      <BookingForm />
      <Contact />
    </main>
    <Footer />
    <FloatingButtons />
  </div>
);

// CRITICAL: Detect session_id in URL hash synchronously, BEFORE normal routes,
// so AuthCallback exchanges the token before ProtectedRoute/AuthProvider checks run.
const AppRouter = () => {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(212,175,55,0.35)",
              color: "#fff",
            },
          }}
        />
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
